import { useRef, useLayoutEffect } from 'react';

const useInputCaret = ({
  inputRef,
  value,
  format,
  variants,
  onValueChange,
  nextInputRef
}) => {
  const pendingValueIndexRef = useRef(null);
  const lastKeyRef = useRef("");
  const getCursorPosition = (value2, digitCount) => {
    let nextCursor = 0;
    let numberCount = 0;
    while (nextCursor < value2.length && numberCount < digitCount) {
      if (/\d/.test(value2[nextCursor])) {
        numberCount += 1;
      }
      nextCursor += 1;
    }
    return nextCursor;
  };
  const handleKeyDown = (e) => {
    lastKeyRef.current = e.key;
    if (e.key === "Enter") {
      if (nextInputRef?.current) {
        e.preventDefault();
        nextInputRef.current.focus();
        return;
      }
    }
  };
  const handleChange = (e) => {
    const input = e.currentTarget;
    const inputValue = input.value;
    const prevCursor = input.selectionStart ?? inputValue.length;
    console.log("$$$$$$", inputValue);
    let digitIndex = inputValue.slice(0, prevCursor).replace(/\D/g, "").length;
    let numbers = variants === "price" ? inputValue.replace(/[^\d]/g, "") : inputValue;
    if (variants === "price" && inputValue.length < value.length && numbers === value.replace(/\D/g, "")) {
      if (lastKeyRef.current === "Delete") {
        numbers = numbers.slice(0, digitIndex) + numbers.slice(digitIndex + 1);
      } else if (digitIndex > 0) {
        numbers = numbers.slice(0, digitIndex - 1) + numbers.slice(digitIndex);
        digitIndex -= 1;
      }
    }
    const formattedValue = format ? format(numbers) : numbers;
    if (formattedValue === value) {
      input.value = formattedValue;
      const pos = getCursorPosition(formattedValue, digitIndex);
      input.setSelectionRange(pos, pos);
      return;
    }
    pendingValueIndexRef.current = digitIndex;
    e.target.value = formattedValue;
    onValueChange(formattedValue, e);
  };
  useLayoutEffect(() => {
    const valueIndex = pendingValueIndexRef.current;
    if (valueIndex === null) return;
    const input = inputRef.current;
    if (!input) return;
    const cursorPosition = getCursorPosition(value, valueIndex);
    input.setSelectionRange(cursorPosition, cursorPosition);
    pendingValueIndexRef.current = null;
  }, [inputRef, value]);
  return {
    handleKeyDown,
    handleChange
  };
};

export { useInputCaret };
